<script>
export default {
  name: 'UlBtnDefault',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click() {
      this.$emit('click');
    },
  },
};
</script>
<template>
  <button
    class="ul-btn-default"
    :disabled="disabled"
    type="button"
    @click="click"
  >
    <slot></slot>
  </button>
</template>
<style lang="scss">
  .ul-btn-default {
    background: 0 0;
    border: none;
    border-radius: 2px;
    color: #000;
    position: relative;
    height: 36px;
    margin: 0;
    min-width: 64px;
    padding: 0 16px;
    display: inline-block;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0;
    overflow: hidden;
    will-change: box-shadow;
    transition: box-shadow .2s cubic-bezier(.4, 0, 1, 1), background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1);
    outline: none;
    cursor: pointer;
    text-decoration: none;
    text-align: center;
    line-height: 36px;
    vertical-align: middle;

    &:hover {
      background-color: rgba(158, 158, 158, .2);
    }

    &:active {
      background-color: rgba(158, 158, 158, .4);
    }

    &:focus {
      background-color: rgba(0, 0, 0, .12);
    }

    &:disabled {
      color: rgba(0, 0, 0, .26);
      cursor: default;
      background-color: transparent;
    }
  }
</style>
